module.exports = __webpack_public_path__ + "img/about_04.825b601d.png";